import $ from 'jquery';

let currentTextSize = localStorage.getItem('current-text-size') || 'normal';
let currentContrast = localStorage.getItem('current-contrast') || 'normal';

const storeTextSize = () => localStorage.setItem('current-text-size', currentTextSize.toString());
const storeContrast = () => localStorage.setItem('current-contrast', currentContrast.toString());

const applyChanges = () => {
    const $html = $('html');
    $html.attr('data-text-size', currentTextSize);
    if (currentContrast === 'high') {
        $html.addClass('contrast');
    } else {
        $html.removeClass('contrast');
    }
};

applyChanges();

$('.access__toggle-link').on('click', ev => {
    ev.preventDefault();
    const $this = $(ev.currentTarget);
    $this.closest('.access').toggleClass('access--open');
});

$('a[href="#text-resize"]').on('click', ev => {
    const rotation = {
        normal: 'medium',
        medium: 'large',
        large: 'normal',
    };
    currentTextSize = rotation[currentTextSize] || 'normal';
    storeTextSize();
    applyChanges();
});

$('a[href="#toggle-contrast"]').on('click', ev => {
    currentContrast = currentContrast === 'normal' ? 'high' : 'normal';
    storeContrast();
    applyChanges();
});


$(document).on('click', ev => {
    const $target = $(ev.target);
    if ($target.closest('.access').length === 0) {
        $('.access').removeClass('access--open');
    }
});
